import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../features/navigation/Navigation';
import Footer from '../features/navigation/Footer';
import './LegalPages.styles.css';

// * [PAGE] Custom 404 Error Page meeting architectural standards
export const NotFoundPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    document.title = '404 - Page Not Found | Yash Haldiya';
  }, []);

  return (
    <div className="legal-page-layout">
      <Navigation />

      <main className="legal-page-container" style={{ textAlign: 'center' }}>
        <div className="legal-document-card" style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ fontSize: '4.5rem', fontWeight: '900', color: 'var(--primary)', lineHeight: 1, marginBottom: '0.5rem' }}>
            404
          </div>
          <span className="legal-badge">Page Not Found</span>
          <h1 className="legal-title" style={{ fontSize: '2rem', marginTop: '0.75rem', marginBottom: '1rem' }}>
            Looking for something?
          </h1>
          <p className="legal-body" style={{ marginBottom: '2rem' }}>
            The page or resource you requested does not exist or has been relocated within the portfolio.
          </p>

          <Link to="/" className="btn btn-primary">
            <i className="fas fa-home" /> Back to Home
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
